var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-locale-provider',{attrs:{"locale":_vm.currentLocale}},[_c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.title),expression:"title"}],class:{'aside-collapsed':_vm.isCollapse},attrs:{"id":"app"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }